export default __webpack_public_path__ + "static/media/Darsh.df10ff17.jpeg";